<template>
  <div class="confirm-page">
    <van-nav-bar
      title="资质认证"
      left-arrow
      fixed
      placeholder
      @click-left="$router.go(-1)"
    />
    <div class="head">
      <el-image
        class="icon"
        :src="require('@/assets/images/simulation/icon_confirm.png')"
        fit="cover"
      ></el-image>
      <p class="title">结算账户信息确认</p>
      <p class="tips-text">请确认你的实名认证信息</p>
    </div>

    <div style="padding: 10px">
      <div class="info">
        <van-radio-group v-model="radio">
          <van-cell center>
            <template #title>
              <p class="name">抖音账号实名：{{ EncryptName(form.realName) }}</p>
              <p class="number">证件号：{{ EncryptCert(form.idNumber) }}</p>
            </template>
            <template #right-icon>
              <van-radio :name="1" checked-color="#ee0a24" icon-size="16px" />
            </template>
          </van-cell>
        </van-radio-group>
      </div>
      <div class="btn" @click="handleNext">下一步</div>
    </div>
  </div>
</template>

<script>
import "vant/lib/index.css";
import { NavBar, Cell, Radio, RadioGroup } from "vant";
export default {
  props: {
    form: Object,
  },
  components: {
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },
  data() {
    return {
      radio: 1,
    };
  },
  methods: {
    EncryptName(name) {
      let newStr;
      if (name.length === 2) {
        newStr = "*" + name.substr(-1, 1);
      } else if (name.length > 2) {
        let char = "";
        for (let i = 0, len = name.length - 2; i < len; i++) {
          char += "*";
        }
        newStr = name.substr(0, 1) + char + name.substr(-1, 1);
      } else {
        newStr = name;
      }

      return newStr;
    },
    EncryptCert(cert) {
      return cert.replace(/^(.{3})(?:\d+)(.{4})$/, "$1*********$2");
    },
    handleNext() {
      this.$router.replace("/simulation/douyinchuchuang/certification");
    },
  },
};
</script>

<style lang="less" scoped>
.confirm-page {
  .head {
    padding: 30px 0 60px;
    text-align: center;
    background-color: #fff;
    .title {
      margin: 10px 0;
      font-size: 16px;
      font-weight: bold;
    }
    .tips-text {
      color: #909399;
    }
  }
  .btn {
    position: absolute;
    bottom: 10px;
    width: 94%;
    padding: 10px 0;
    text-align: center;
    color: #fff;
    background-color: #e21e48;
    border-radius: 3px;
    user-select: none;
    cursor: pointer;
  }
}
</style>